<template>
  <div class="input">
    <div class="input-label">電話番号</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="tel">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    tel: {
      get: function () {
        return this.$store.state.user.tel
      },
      set: function (value) {
        this.$store.commit(
          'user/setTel',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
